import React, { Component, Fragment } from 'react';
import * as NavigationAction from '@flow/store/navigation/actions';
import { connect } from 'react-redux';
import { withRouteData, Switch, Route } from 'react-static';
import { IPage } from 'types/IPage';
import SimplePage from '@flow/scenes/simple/SimplePage';
import {
  SingleColumnLayout,
  SingleColumnLayoutContentWrapper,
  SingleColumnLayoutHeader
} from '@flow/components/ui';
import { PROGRAM_PAGE_NAVIGATION_ENABLED } from '@flow/utils/constants';
import { renderContent } from '@flow/scenes/default/ui';
import SEOTags from '@flow/components/seo/SEOTags';
import { ProgramNavigation } from '@flow/components/navigation/ProgramNavigation';
import { renderList } from '@flow/components/grid/grid';

type Props = {
  appLanguage: IAppLanguage;
  slugBases: any;
  entries: any;
  page: IPage;
  _setLanguage: any;
  match: any;
  programPageNavigation: ProgramPageNavigation;
}

class Family extends Component<Props> {

  componentWillMount() {
    const {
      appLanguage,
      _setLanguage,
      page,
    } = this.props;

    const lang_versions = page && page.lang_versions;

    _setLanguage({ appLanguage, lang_versions});
  }

  componentWillReceiveProps({
    appLanguage,
    page,
  }: Props) {
    const {
      _setLanguage,
    } = this.props;

    const lang_versions = page && page.lang_versions;

    _setLanguage({ appLanguage, lang_versions });
  }

  render() {
    const {
      page,
      match: {
        url
      },
      entries,
      programPageNavigation,
    } = this.props;

    let content_group: any = page ? page.content_group : undefined;

    return (
      <Switch>
        <Route
          path={url}
          exact
          render={() => {
            return (
              <Fragment>
                <SingleColumnLayout>
                  <SEOTags page={page} />
                  <SingleColumnLayoutHeader>
                    {PROGRAM_PAGE_NAVIGATION_ENABLED ? (
                      <ProgramNavigation programPageNavigation={programPageNavigation} />
                    ) : (
                      <h2>{page.title}</h2>
                    )}
                  </SingleColumnLayoutHeader>
                  {Boolean(content_group) && (
                    <SingleColumnLayoutContentWrapper>
                      { content_group && renderContent(content_group) }
                    </SingleColumnLayoutContentWrapper>
                  )}
                  { entries && renderList('family', entries)}
                </SingleColumnLayout>
              </Fragment>
            );
          }}
        />
        <Route path={`${url}/:familyId/`} component={SimplePage} />
      </Switch>
    )
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    _setLanguage: ({appLanguage, lang_versions }: ISetLanguage) => {
      dispatch(NavigationAction.setLanguage(appLanguage, lang_versions));
    }
  };
};

export default connect(
  null,
  mapDispatchToProps
)(withRouteData(Family));


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/scenes/family/Family.tsx